var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3092 16.1049C16.2616 16.9886 19.1485 14.4559 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 4.28179 18.8702 7 19C8.76848 19.0844 9.29727 18.0849 9.74826 17.2325C10.1137 16.5418 10.428 15.9476 11.3092 16.1049ZM14 13C15.1046 13 16 12.1046 16 11C16 9.89543 15.1046 9 14 9C12.8954 9 12 9.89543 12 11C12 12.1046 12.8954 13 14 13Z",
    fill: "currentColor",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46633 6.75C8.27646 7.74215 7.21664 8.75 5.98325 8.75C4.74986 8.75 3.75 7.85457 3.75 6.75C3.75 5.64543 4.74986 4.75 5.98325 4.75C7.21664 4.75 7.46633 5.64543 7.46633 6.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.64353C14 6.58749 13.043 6.12708 12.1333 6.58749C13.5989 7.26456 10 8.64578 10 5.64353C10 4.45969 10.8954 3.5 12 3.5C13.1046 3.5 14 4.45969 14 5.64353Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.0418C8.75 14.1694 8.13746 15.238 6.62369 14.3821C5.80858 15.9513 3.75 14.1694 3.75 13.0418C3.75 11.9141 4.86929 11 6.25 11C7.63071 11 8.75 11.9141 8.75 13.0418Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesign);
export default __webpack_public_path__ + "static/media/icon-design.ecdc2b8d9a582fd0a945dab7fc3288e9.svg";
export { ForwardRef as ReactComponent };